/**
 * `refresh-cw-05` glyph (Untitled UI). Two arrows curving in
 * opposite directions to convey a retry / refresh action. Uses
 * `currentColor` so the enclosing button controls the stroke.
 *
 * Stroke is `2` against the 16-unit viewBox so the effective
 * stroke holds visual weight at the Figma `Link-Button/Web` target
 * size of 12px (`2 * 12/16 = 1.5px`). At any larger render size the
 * stroke scales proportionally and still reads as the Untitled UI
 * glyph weight.
 */
export type RefreshIconProps = {
  /**
   * Rendered width/height in px. Defaults to 12 to match the Figma
   * `Link-Button/Web` component (node `15703:85571` /
   * `15703:85612`). Pass an explicit value for any other surface.
   */
  size?: number;
  className?: string;
};

function RefreshIcon({ size = 12, className }: RefreshIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14.6667 2.66667V6M14.6667 6H11.3333M14.6667 6L12.0467 3.54C11.4193 2.91187 10.6411 2.45396 9.78706 2.21008C8.93302 1.96619 8.0306 1.94443 7.16586 2.14686C6.30113 2.34928 5.50194 2.7692 4.84539 3.36589C4.18884 3.96258 3.69648 4.71653 3.41333 5.55333M1.33333 13.3333V10M1.33333 10H4.66667M1.33333 10L3.95333 12.46C4.58068 13.0881 5.35891 13.5461 6.21295 13.7899C7.067 14.0338 7.96941 14.0556 8.83415 13.8531C9.69888 13.6507 10.4981 13.2308 11.1546 12.6341C11.8112 12.0374 12.3035 11.2835 12.5867 10.4467"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default RefreshIcon;
